<template>
    <div class="fl-icon" ref="icon" v-html="svg"></div>
</template>

<style>

.fl-icon {
    width: 1rem;
    height: 1rem;
    display: inline-block;
    font-size: inherit;
    -webkit-filter: invert(100%);
    /* margin-top: -0.2em !important; */
}

</style>


<script>
export default {
    data() {
        return {
            svg: ''
        };
    },

    props: {
        name: {
            type: String,
            required: true
        },
    },

    created() {
        this.svg = require(`../../assets/svg/${this.name}.svg`);
    }
}
</script>



// WEBPACK FOOTER //
// src/components/fl-icon/main.vue